import React from 'react';
import { EuiFlexGroup, EuiText, EuiButton } from '@elastic/eui';
import { useRouter } from 'next/router';
import { MdOpenInBrowser } from 'react-icons/md';

interface Props {
  textColor: string;
  backgroundColor: string;
  message: string;
  showButton?: boolean;
}

const Announcement: React.FunctionComponent<Props> = props => {
  const { textColor, backgroundColor, message, showButton } = props;
  const router = useRouter();
  return (
    <EuiFlexGroup
      justifyContent="center"
      alignItems="center"
      css={{
        background: backgroundColor,
        padding: '10px',
        maxHeight: '50px',
        width: '100%',
      }}>
      <EuiText size="s" color={textColor} textAlign="center">
        <strong>{message}</strong>
      </EuiText>
      {showButton && (
        <EuiButton
          iconType={MdOpenInBrowser}
          iconSide="right"
          onClick={() =>
            router.push('https://campaign-manager-preview.voteda.org/')
          }
          size="s">
          Open New Campaign Manager
        </EuiButton>
      )}
    </EuiFlexGroup>
  );
};

export default Announcement;
